/**
 * Lazy Loading Enhancement
 * Automatically adds native lazy loading to images below the fold
 * Improves LCP by prioritizing above-the-fold content
 */

(function() {
  'use strict';

  // Skip if browser doesn't support lazy loading
  if (!('loading' in HTMLImageElement.prototype)) {
    return;
  }

  /**
   * Add lazy loading to images below the fold
   */
  function enhanceLazyLoading() {
    const viewportHeight = window.innerHeight;
    const images = document.querySelectorAll('img:not([loading])');

    images.forEach((img) => {
      // Skip if image already has loading attribute
      if (img.hasAttribute('loading')) return;

      // Check if image is below the fold (with 200px buffer)
      const rect = img.getBoundingClientRect();
      const isBelowFold = rect.top > viewportHeight + 200;

      if (isBelowFold) {
        img.setAttribute('loading', 'lazy');
      } else {
        // Images at or near viewport should load immediately
        img.setAttribute('loading', 'eager');
      }
    });
  }

  /**
   * Add fetchpriority="low" to images far below the fold
   */
  function addFetchPriority() {
    const viewportHeight = window.innerHeight;
    const images = document.querySelectorAll('img[loading="lazy"]:not([fetchpriority])');

    images.forEach((img) => {
      const rect = img.getBoundingClientRect();
      const distanceBelowFold = rect.top - viewportHeight;

      // Images very far below fold get low priority
      if (distanceBelowFold > 1000) {
        img.setAttribute('fetchpriority', 'low');
      }
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      enhanceLazyLoading();
      addFetchPriority();
    });
  } else {
    enhanceLazyLoading();
    addFetchPriority();
  }

  // Re-run after dynamic content loads
  const observer = new MutationObserver(function(mutations) {
    let hasNewImages = false;

    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          if (node.tagName === 'IMG' || node.querySelector('img')) {
            hasNewImages = true;
          }
        }
      });
    });

    if (hasNewImages) {
      enhanceLazyLoading();
      addFetchPriority();
    }
  });

  // Observe body for dynamic content
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Stop observing after 10 seconds to avoid performance impact
    setTimeout(function() {
      observer.disconnect();
    }, 10000);
  }
})();
